import { useQuery, useMutation } from "@tanstack/react-query";
import {
  createPricelistDetail,
  getBillingRate,
} from "services/pricelistdetail";

export const useCreatePricelistDetail = () => {
  const query = useMutation({
    mutationFn: (data) => createPricelistDetail(data),
  });
  return query;
};

export const useGetBillingRate = () => {
  const query = useMutation({
    mutationFn: (data) => getBillingRate(data),
  });
  return query;
};
